import { Consignment } from 'src/@core/models';
import { Subject } from "rxjs";
import { Injectable } from "@angular/core";


class EventService<T> {
  protected _eventSubject = new Subject<T>();
  public events = this._eventSubject.asObservable();

  dispathEvent(data: T) {
    this._eventSubject.next(data);
  }
}

@Injectable()
export class DeleteConsignmentEvent extends EventService<string> {

}

@Injectable()
export class ActivateEmailPodEvent extends EventService<boolean> {

}

@Injectable()
export class NewConsignmentEvent extends EventService<Consignment> {

}

@Injectable()
export class EditConsignmentEvent extends EventService<Consignment> {

}